/**
 * Delivery item layouts for new_delivery / success_delivery dialogs.
 * From concept.svg group `items` (layers 1…33 → 1.png…33.png).
 * Design space 1080×1920.
 * width×height = design AABB; DeliveryItemImage uses object-fit: contain (aspect preserved).
 */
export type DeliveryItemLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
};

/** Key — asset file number (same as SVG layer name). */
export const DELIVERY_ITEM_DIALOG_LAYOUTS: Record<number, DeliveryItemLayout> = {
  1: {
    left: 383,
    top: 1146.23,
    width: 332.52,
    height: 313.54,
  },
  2: {
    left: 424.73,
    top: 1118.53,
    width: 249.38,
    height: 322.73,
  },
  3: {
    left: 367.85,
    top: 1155.91,
    width: 361.53,
    height: 291.59,
  },
  4: {
    left: 397.55,
    top: 1151.25,
    width: 302.89,
    height: 302.9,
  },
  5: {
    left: 419.37,
    top: 1159.23,
    width: 260.14,
    height: 292.54,
  },
  6: {
    left: 459.94,
    top: 1153.4,
    width: 188.63,
    height: 298.53,
  },
  7: {
    left: 398,
    top: 1160,
    width: 310.41,
    height: 286.39,
  },
  8: {
    left: 314.95,
    top: 1196.28,
    width: 466.67,
    height: 212.35,
  },
  9: {
    left: 404.83,
    top: 1157.63,
    width: 286.01,
    height: 297.2,
  },
  10: {
    left: 403,
    top: 1151.23,
    width: 302.56,
    height: 304.55,
  },
  11: {
    left: 381.64,
    top: 1167.23,
    width: 326.04,
    height: 326.43,
  },
  12: {
    left: 419.23,
    top: 1155.4,
    width: 260.29,
    height: 295.08,
  },
  13: {
    left: 415,
    top: 1168.23,
    width: 268.45,
    height: 268.45,
  },
  14: {
    left: 471,
    top: 1155.23,
    width: 157.74,
    height: 294.57,
  },
  15: {
    left: 423.29,
    top: 1161.42,
    width: 254.02,
    height: 279.05,
  },
  16: {
    left: 424.19,
    top: 1148,
    width: 263.29,
    height: 303.1,
  },
  17: {
    left: 427.3,
    top: 1162.5,
    width: 243.84,
    height: 281.02,
  },
  18: {
    left: 352.96,
    top: 1139.93,
    width: 337.48,
    height: 315.33,
  },
  19: {
    left: 377,
    top: 1158.01,
    width: 344.27,
    height: 289.01,
  },
  20: {
    left: 365.99,
    top: 1221.63,
    width: 366.37,
    height: 160.17,
  },
  21: {
    left: 407.24,
    top: 1181.23,
    width: 274.95,
    height: 243.78,
  },
  22: {
    left: 385.65,
    top: 1149.36,
    width: 323.6,
    height: 310.91,
  },
  23: {
    left: 354,
    top: 1153.73,
    width: 389.92,
    height: 298.64,
  },
  24: {
    left: 307.92,
    top: 1206.78,
    width: 461.44,
    height: 181.59,
  },
  25: {
    left: 423.76,
    top: 1159.46,
    width: 245.8,
    height: 284.66,
  },
  26: {
    left: 401.94,
    top: 1147.75,
    width: 278.05,
    height: 310.8,
  },
  27: {
    left: 474.61,
    top: 1160.23,
    width: 148.68,
    height: 285,
  },
  28: {
    left: 336.2,
    top: 1154.4,
    width: 405.02,
    height: 289.36,
  },
  29: {
    left: 431.95,
    top: 1152.2,
    width: 234.28,
    height: 301.45,
  },
  30: {
    left: 402,
    top: 1188.23,
    width: 294.43,
    height: 229.92,
  },
  31: {
    left: 455.34,
    top: 1157.18,
    width: 200.39,
    height: 291.92,
  },
  32: {
    left: 449,
    top: 1170.04,
    width: 199.32,
    height: 262.28,
  },
  33: {
    left: 393.59,
    top: 1137.4,
    width: 337.49,
    height: 310.59,
  },
};

export function getDeliveryItemDialogLayout(
  assetIndex: number,
): DeliveryItemLayout | undefined {
  return DELIVERY_ITEM_DIALOG_LAYOUTS[assetIndex];
}
